import React from "react";

import { ImageSearchPill } from "./ImageSearchPill";
import { ISuggestionEntry } from "./Interfaces";
import { PillsWithImageRow } from "./PillsWithImageRow";
import { getSuggestionUrl } from "./utils";

export const TrendingSearches: React.FC<{
  suggestionArray: ISuggestionEntry[];
  sectionHeader: string;
  sectionIndex: number;
  query: string;
  onSuggestionClick: (
    sectionHeader: string,
    sectionIndex: number,
    suggestion: ISuggestionEntry,
    suggestionIndex: number,
    navigate: boolean
  ) => void;
  onSuggestionHover: (index: number, url?: string) => void;
  onSuggestionBlur: () => void;
  getSuggestionIndex: () => number;
  isSuggestionSelected: (index: number) => boolean;
}> = ({
  suggestionArray,
  sectionHeader,
  sectionIndex,
  query,
  onSuggestionClick,
  onSuggestionHover,
  onSuggestionBlur,
  getSuggestionIndex,
  isSuggestionSelected,
}) => {
  return (
    <PillsWithImageRow
      suggestionArray={suggestionArray}
      sectionHeader={sectionHeader}
      sectionIndex={sectionIndex}
      query={query}
    >
      {suggestionArray.map(
        (suggestion: ISuggestionEntry, suggestionIndex: number) => {
          const index = getSuggestionIndex();
          return (
            <ImageSearchPill
              key={suggestion.url + index.toString()}
              selected={isSuggestionSelected(index)}
              onHover={() => onSuggestionHover(index, suggestion.url)}
              onMouseLeave={() => {
                onSuggestionBlur();
                onSuggestionHover(-1);
              }}
              onClick={() =>
                onSuggestionClick(
                  sectionHeader,
                  sectionIndex,
                  suggestion,
                  suggestionIndex,
                  false
                )
              }
              suggestion={suggestion}
              url={getSuggestionUrl(suggestion.url)}
              dataTestId="search-recommendation-pill"
            />
          );
        }
      )}
    </PillsWithImageRow>
  );
};
